// HorizontalSeparatorControlView.js

import { View } from 'backbone';
import eventBus         from 'EventBus.js';

import BaseControlView from 'BaseControlView.js';
import template from 'advanced-visuals/control-horizontal-separator.ejs';
import themeService     from 'ThemeService.js';
import constants        from "Constants";

//=====================================================================
//
// An instance of this view represents a horiztontal separator control
//
// Lou Mauget, November 8, 2015
//
//=====================================================================
class HorizontalSeparatorControlView extends BaseControlView  {

        initialize( opts ) {

            super.initialize( opts );
            this.template = template;
            this.tagName = 'div';
            this.model.set('height', themeService.resolve('~seperatorSize'), {silent: true} );
            this.events = {
            };

            this.listenTo(this.model, 'change', this.render);
            this.listenTo( eventBus, 'SeparatorThemeChange', this.themeChangeRender );
            this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);
            return this;
        }

        // Neighbor aligner uses this polymorphic property, looking for
        // value 'BaseStaticTextControl'
        get kind() {
            return 'HorizontalSeparatorControlView';
        }

}

export default HorizontalSeparatorControlView;

